export default __webpack_public_path__ + "static/media/recording-active.40682fa6.svg";